import { render, staticRenderFns } from "./LocationsId.vue?vue&type=template&id=44062769&"
import script from "./LocationsId.vue?vue&type=script&lang=js&"
export * from "./LocationsId.vue?vue&type=script&lang=js&"
import style0 from "./LocationsId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports